import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentViewerComponent } from './document-viewer/document-viewer.component';
import { MaterialModule } from '../material/material.module';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { PdfViewerComponent } from './file-viewers/pdf-viewer/pdf-viewer.component';
import { ImageViewerComponent } from './file-viewers/image-viewer/image-viewer.component';
import { FormsModule } from '@angular/forms';
import { DocumentViewerBlobStorageComponent } from './document-viewer-blob-storage/document-viewer-blob-storage.component';

@NgModule({
  declarations: [
    DocumentViewerComponent,
    PdfViewerComponent,
    ImageViewerComponent,
    DocumentViewerBlobStorageComponent,
  ],
  imports: [CommonModule, MaterialModule, NgxExtendedPdfViewerModule, FormsModule],
  exports: [DocumentViewerComponent, DocumentViewerBlobStorageComponent, PdfViewerComponent],
})
export class DocumentViewerModule {}
